import ApplicationConf from 'conf/ApplicationConf'
import { aquaFetch } from 'common/utils/ActionUtils'
import { toast } from 'react-toastify'

const IssuesAction = {
    createIssues:
        async (file, setIsOpen, setErrors) => {
            try {
                const response = aquaFetch(ApplicationConf.support.createIssues(), { body: { name: file.name, content: file.content }, method: 'POST' }, { 400: (res) => {
                    throw res
                } })
                toast.promise(response,
                    {
                        pending: 'Création des tickets en cours',
                        success: 'Les tickets ont bien été créés',
                        error: 'Erreur lors de la création des tickets',
                    },
                )
                return await response
            } catch (err) {
                const errs = err.statusText.split(';').filter(e => !!e) // car il y a un ; à la fin donc un string vide

                setIsOpen(true)
                setErrors(errs)

                toast.error('Erreur lors de la création des tickets')
            }
        },

    updateIssues:
        async (tickets) => {
            try {
                const response = await aquaFetch(ApplicationConf.support.updateIssues(),
                    {
                        body: tickets.map(t => ({
                            idIssue: t.id,
                            edit: {
                                ...t,
                                progress: t.avancement,
                                estimatedTime: t.chiffrage ? `${t.chiffrage}` : undefined,
                            },
                        })),
                        method: 'POST',
                    },
                )
                toast.success('Tickets modifiés avec succès')
                return response
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err)
                toast.error('Erreur lors de la modification des tickets')
            }
        },
    addNote:
        async (idIssue, content, files) => {
            try {
                const response = await aquaFetch(ApplicationConf.support.addNote(),
                    {
                        body: {
                            idIssue,
                            content,
                            files,
                        },
                        method: 'POST',
                    },
                )
                toast.success('Note ajoutée avec succès')
                return response
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err)
                toast.error('Erreur lors de la création de la note')
            }
        },
    issuesMEI:
        async (iaeau = false) => {
            try {
                const response = await aquaFetch(iaeau ? ApplicationConf.support.issuesMEIIaeau() : ApplicationConf.support.issuesMEI(),
                    {
                        method: 'PUT',
                    },
                )
                toast.success('Tickets ajoutés à la recette avec succès')
                return response
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err)
                toast.error('Erreur lors de l\'ajout des tickets dans la recette')
            }
        },
    endRecette:
        async (version, iaeau = false) => {
            try {
                const response = await aquaFetch(iaeau ? ApplicationConf.support.endRecetteIaeau() : ApplicationConf.support.endRecette(),
                    {
                        body: {
                            version,
                        },
                        method: 'PUT',
                    },
                )
                toast.success('Tickets validés avec succès')
                return response
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err)
                toast.error('Erreur lors de la validation des tickets')
            }
        },
}

export default IssuesAction